module.exports = __webpack_public_path__ + "static/media/phone.4ad0cc4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/preferences/security/phone.png
// module id = 1347
// module chunks = 0